import { render, staticRenderFns } from "./TestarModalSolicitacoes.vue?vue&type=template&id=5df38b81&scoped=true&"
import script from "./TestarModalSolicitacoes.vue?vue&type=script&lang=js&"
export * from "./TestarModalSolicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./TestarModalSolicitacoes.vue?vue&type=style&index=0&id=5df38b81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df38b81",
  null
  
)

export default component.exports